module.exports = __webpack_public_path__ + "static/media/Diversity Logo with Text (300 dpi)_1725636367589.6762c9aa.png";